import { PostalCodeDto, PostalCodeModel } from '../types/postal-code'

export const transformPostalCodeDto = (postalCode: PostalCodeDto): PostalCodeModel => ({
  cities: postalCode.cities,
  code: postalCode.code,
  state: postalCode.state,
})
